import L from 'leaflet';
import { objectColors } from '@iso/constants/objectColors';
import { createMachineryIcon } from './AssetIcons/machinery_icon';
import { livestockIcons } from './AssetIcons/livestock_icons';
import { waterInfrastructureIcons } from './AssetIcons/water_infrastructure_icons';
import { farmChemicalIcons } from './AssetIcons/farm_chemicals_icons';
import { equipmentIcons } from './AssetIcons/equipment_icons';
import { inventoryIcons } from './AssetIcons/inventory_icons';
import { createDefaultIcon, DEFAULT_ICON_MARKER } from './AssetIcons/default_icon';
import _ from 'lodash';
import { normalizeHealthSafetyType } from '@iso/constants/healthSafetyTypes';
import { healthSafetyIconMap } from '@iso/constants/healthSafetyIconMap';

export const IconAsset = (category, tag_colour = null, animal_type, type, status = null) => {
  if(tag_colour){
    var asset_color = '';
    _.forEach(objectColors, (color_obj, index) => {
        if(color_obj.value === tag_colour){
          asset_color = color_obj.color;
        }
    })
  }
  var icon_url = '';

  switch(category){
    case 'inventory':
      switch(type){
        case 'chemical':
          icon_url = farmChemicalIcons.chemical(status);
          break;
        case 'fertiliser':
          icon_url = farmChemicalIcons.fertiliser(status);
          break;
        case 'fuel':
          icon_url = farmChemicalIcons.fuel(status);
          break;
        case 'vaccine':
          icon_url = farmChemicalIcons.vaccine(status);
          break;
        case 'animal_treatment':
          icon_url = farmChemicalIcons.animalTreatment(status);
          break;
        case 'stock_feed':
          icon_url = inventoryIcons.hay(status);
          break;
        case 'aircraft':
          icon_url = equipmentIcons.aircraft(status);
          break;
        case 'water':
          icon_url = inventoryIcons.tank(status);
          break;
        case 'other':
          icon_url = inventoryIcons.other(status);
          break;
        default:
          icon_url = DEFAULT_ICON_MARKER;
      }
      break;
    case 'machinery':
      icon_url = createMachineryIcon(0, status);
      break;
    case 'property':
      icon_url = equipmentIcons.homestead(status);
      break;
    case 'shed':
      switch (type){
        case 'fuel':
          icon_url = farmChemicalIcons.fuel(status);
          break;
        case 'hay':
          icon_url = inventoryIcons.hay(status);
          break;
        default:
          icon_url = equipmentIcons.shed(status);
      }
      break;
    case 'fencing':
      icon_url = equipmentIcons.fencing(status);
      break;
    case 'storage':
      icon_url = equipmentIcons.shed(status);
      break;
    case 'aircraft':
      icon_url = equipmentIcons.aircraft(status);
      break;
    case 'water':
      switch(type) {
        case 'dam':
          icon_url = waterInfrastructureIcons.dam(status);
          break;
        case 'tank':
          icon_url = waterInfrastructureIcons.tank(status);
          break;
        case 'trough':
          icon_url = waterInfrastructureIcons.trough(status);
          break;
        case 'bore':
          icon_url = waterInfrastructureIcons.bore(status);
          break;
        case 'windmill':
          icon_url = waterInfrastructureIcons.windmill(status);
          break;
        default:
          icon_url = waterInfrastructureIcons.water(status);
      }
      break;
    case 'animal':
      switch(animal_type){
        case 'chicken':
          icon_url = livestockIcons.chicken(asset_color);
          break;
        case 'horse':
          icon_url = livestockIcons.horse(asset_color);
          break;
        case 'dog':
          icon_url = livestockIcons.dog(asset_color);
          break;
        case 'bull':
          icon_url = livestockIcons.bull(asset_color);
          break;
        case 'pig':
          icon_url = livestockIcons.pig(asset_color);
          break;
        case 'cow':
          icon_url = livestockIcons.cow(asset_color);
          break;
        case 'ram':
          icon_url = livestockIcons.sheep(asset_color);
          break;
        case 'ai':
          icon_url = livestockIcons.otherAnimal(asset_color);
          break;
        default:
          icon_url = livestockIcons.otherAnimal(asset_color);
      }
      break;
    case 'weather':
      icon_url = equipmentIcons.weather(status);
      break;
    case 'health_and_safety': {
      const normalizedType = normalizeHealthSafetyType(type);
      const iconFunction = healthSafetyIconMap[normalizedType];
      icon_url = iconFunction ? iconFunction(status) : DEFAULT_ICON_MARKER;
      break;
    }
    default:
      icon_url = DEFAULT_ICON_MARKER;
  }

  // Replace default icon marker with actual icon
  if (icon_url === DEFAULT_ICON_MARKER) {
    icon_url = createDefaultIcon(status);
  }

  // Check if icon is SVG data URL (all state-based icons including default)
  const isSvgIcon = icon_url.startsWith('data:image/svg+xml');
  var iconSize = isSvgIcon ? [94, 104] : [44, 60];
  var iconAnchor = isSvgIcon ? [34, 75] : [22, 60];

  var icon = new L.Icon({
    iconUrl: icon_url,
    popupAnchor: null,
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    iconSize: iconSize,
    iconAnchor: iconAnchor,
    className: `custom-icon-marker asset asset_category_${category}`
  });

  return icon;
};
